<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="3">
                <el-input placeholder="设备编号" v-model="devId"></el-input>
            </el-col>
            <el-col :span="3">
                <el-input placeholder="型号" v-model="termVersion"></el-input>
            </el-col>
            <el-col :span="3">
                <el-input placeholder="批号" v-model="batch"></el-input>
            </el-col>
            <el-col :span="3">
                <el-select v-model="storeStatus">
                    <el-option value="" label="库存状态"></el-option>
                    <el-option value="0" label="待入库"></el-option>
                    <el-option value="1" label="入库"></el-option>
                    <el-option value="2" label="出库"></el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-date-picker
                    v-model="value1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-col>
        </el-row>
        <el-row class="search-add">
            <el-col :span="2">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="devId" label="设备编号">
            </el-table-column>
            <el-table-column prop="name" label="设备名称">
            </el-table-column>
            <el-table-column prop="termVersion" label="设备型号">
            </el-table-column>
            <el-table-column prop="batch" label="批号">
            </el-table-column>
            <el-table-column prop="storeStatus" label="库存状态">
                <template slot-scope="scope">
                    {{scope.row.storeStatus | kucun}}
                </template>
            </el-table-column>
            <el-table-column prop="addUser" label="添加人">
            </el-table-column>
            <el-table-column prop="date" label="添加日期">
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
    export default {
        name: 'admin',
        data() {
            return {
                devId: '',
                batch: '',
                termVersion: '',
                storeStatus:'',
                value1:'',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        filters:{
            kucun(value) {
                switch(value) {
                    case '0': return '待入库';break;
                    case '1': return '入库';break;
                    case '2': return '出库';break;
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.devId.trim() != '') {
                    params.devId = this.devId;
                }
                if(this.batch.trim() != '') {
                    params.batch = this.batch;
                }
                if(this.termVersion.trim() != '') {
                    params.termVersion = this.termVersion;
                }
                if(this.storeStatus != '') {
                    params.storeStatus = this.storeStatus;
                }
                if(this.value1 != '') {
                    params.start = this.value1[0];
                    params.end = this.value1[1];
                }
                this.$http.post('/manage/addDevRecord/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            }
        },
        components: { Pagination }
    }
</script>

<style scoped>
    .search-add{margin-bottom: 10px;}
</style>